





















/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal para proveedores y registro de subcontratacion para admins
 * @author          Leticia Beltrán
 * @creationDate
 */

import i18nMessages from "../NewRegisterOutsourcing/i18n/messages";
import GlobalMixin from "@/mixins/global";
import FormNewRegisterOutsourcing from "@/components/FormNewRegisterOutsourcing/FormNewRegisterOutsourcing.vue";
import BreadcrumbNav from "@/components/Breadcrumbs/BreadcrumbNav.vue";

export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    FormNewRegisterOutsourcing,
    BreadcrumbNav,
  },
  data() {
    return {
      moduleName: "Registro del Proveedor",
    };
  },
  computed: {
    // Se realizar el mapeo de las propiedades isLoading y locale del STATE (Vuex)
    viewTitle: function () {
      let complemento = ["1", "2"].includes(this.$store.getters["auth/rol"])
        ? " (Autorización)"
        : "";
      return "Registro" + complemento;
    },
  },
  methods: {},
});
